import ProjectFileCategoryApi from '@/api/rest/ProjectFileCategoryApi';

export default new ProjectFileCategoryApi();
